// extracted by mini-css-extract-plugin
module.exports = {"tabbar":"TabBar_tabbar__1xNb7"};